import React, { FC } from 'react';
import { Select } from 'antd';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
	problemTypesRestCrudThunksForBuyer,
	problemTypesRestCrudThunksForSupplier,
} from '../../../thunks/problem_types_thunks';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesRestCrudThunksForSupplier,
} from '../../../thunks/work_order_priorities_thunks';
import { withUserType } from '../../withUserType';
import { connect } from 'react-redux';
import RegionsLocationsTreeSelect from '../../regions_tree_select/RegionsLocationsTreeSelect';
import ProblemTypeTreeSelect from '../../problem_type_tree_select';
import OWAsyncTreeSelect from '../../ow_async_tree_select/OWAsyncTreeSelect';
import SelectWithAllToggle from '../../common/SelectWithAllToggle';
import { nullSafeGet } from '../../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../../utils/DataConstants';

const defaultFormFieldStyle = { maxWidth: 640 };

const TROUBLESHOOTING_FORM_TC_NAME = 'troubleshootingFormIndex';

const TroubleshootingAssociationEditFields: FC<any> = ({
	locations,
	problemTypes,
	fetchProblemTypes,
	workOrderPriorities,
	fetchWorkOrderPriorities,
	fetchMultipleWorkOrderPriorities,
	form,
	displaySelectAllWithLabel = false,
}): React.ReactElement => {
	return (
		<>
			<SelectWithAllToggle
				label="Problem Types"
				name="problemTypeIds"
				allName="allProblemTypes"
				defaultFormFieldStyle={defaultFormFieldStyle}
				form={form}
				displaySelectAllWithLabel={displaySelectAllWithLabel}
			>
				<ProblemTypeTreeSelect
					allowClear={true}
					style={defaultFormFieldStyle}
					stateSlice={problemTypes}
					targetCollectionName={TROUBLESHOOTING_FORM_TC_NAME}
					mode="multiple"
					fetchData={(
						searchText,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
					) =>
						fetchProblemTypes(
							{ name: searchText },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						)
					}
					fetchMultiple={() => {}}
					renderRecord={(pt) => (
						<Select.Option key={pt.id} value={pt.id}>
							{pt.name}
						</Select.Option>
					)}
				/>
			</SelectWithAllToggle>
			<SelectWithAllToggle
				label="Locations"
				name="locationIds"
				allName="allLocations"
				defaultFormFieldStyle={defaultFormFieldStyle}
				form={form}
				displaySelectAllWithLabel={displaySelectAllWithLabel}
			>
				<RegionsLocationsTreeSelect
					style={defaultFormFieldStyle}
					mode="multiple"
					noIsActiveFilter
					filtersSlice={locations}
					targetCollectionName={TROUBLESHOOTING_FORM_TC_NAME}
				/>
			</SelectWithAllToggle>
			<SelectWithAllToggle
				label="Priorities"
				name="workOrderPriorityIds"
				allName="allWOPriorities"
				defaultFormFieldStyle={defaultFormFieldStyle}
				form={form}
				displaySelectAllWithLabel={displaySelectAllWithLabel}
			>
				<OWAsyncTreeSelect
					key="workOrderPriorityIds"
					mode="multiple"
					style={defaultFormFieldStyle}
					stateSlice={workOrderPriorities}
					targetCollectionName={TROUBLESHOOTING_FORM_TC_NAME}
					labelAccessor={(el) => nullSafeGet('name', el)}
					allowClear
					fetchData={(
						search,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
					) =>
						fetchWorkOrderPriorities(
							{ search: search || undefined },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						)
					}
					fetchMultiple={(ids, targetCollectionName) => {
						fetchMultipleWorkOrderPriorities(ids, targetCollectionName);
					}}
					renderRecord={(entity) => {
						return (
							<Select.Option key={entity.id} value={entity.id}>
								{entity.name}
							</Select.Option>
						);
					}}
					sortBy={{ sort_by: 'name', order: 'ascend' }}
				/>
			</SelectWithAllToggle>
		</>
	);
};

const mapStateToProps = (state) => ({
	locations: state.locations,
	problemTypes: state.problem_types,
	workOrderPriorities: state.work_order_priorities,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchMultipleProblemTypes: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: problemTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchProblemTypes: (params, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier(params, targetCollectionName)
				: problemTypesHeirarchicalForBuyer(params, targetCollectionName)
		),
	fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: workOrderPrioritiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchWorkOrderPriorities: (params, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderPrioritiesRestCrudThunksForSupplier.read(params, targetCollectionName)
				: workOrderPrioritiesRestCrudThunksForBuyer.read(params, targetCollectionName)
		),
});

export default withUserType(
	connect(mapStateToProps, mapDispatchToProps)(TroubleshootingAssociationEditFields as any) as any
);
